import React from 'react';
import { SvgIcon } from '@mui/material';

export default function PaymentIcon(props) {
  return (
    <SvgIcon sx={{ width: 48, height: 48 }} {...props}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.5"
          d="M37.7075 19.8339L35.2902 19.0039L9.98881 26.4154L7.42285 33.2196C13.7439 35.246 27.0774 39.4996 29.8437 40.3027C32.61 41.1058 33.7104 39.6334 33.9149 38.7968C35.3092 33.8517 38.1759 23.6491 38.4882 22.3998C38.8005 21.1505 38.8408 20.3963 37.7075 19.8339Z"
          fill="white"
        />
        <mask id="path-2-inside-1_5967_102850" fill="white">
          <rect
            x="4.91211"
            y="14.2266"
            width="30.5777"
            height="19.4278"
            rx="1.33859"
          />
        </mask>
        <rect
          x="4.91211"
          y="14.2266"
          width="30.5777"
          height="19.4278"
          rx="1.33859"
          fill="#4520AB"
          stroke="white"
          strokeWidth="3"
          mask="url(#path-2-inside-1_5967_102850)"
        />
        <rect
          x="4.91211"
          y="20.4766"
          width="30.5777"
          height="3.46411"
          fill="white"
        />
        <rect
          x="10.4102"
          y="29.0488"
          width="2.70266"
          height="0.721581"
          rx="0.360791"
          fill="white"
        />
        <rect
          x="15.374"
          y="29.0488"
          width="6.08115"
          height="0.721581"
          rx="0.360791"
          fill="white"
        />
        <circle cx="35.4902" cy="10.7842" r="8.64746" fill="#29EDFF" />
        <path
          d="M30.2021 16.5189C31.5742 15.0636 33.4369 14.1693 35.4887 14.1693C37.5404 14.1693 39.4032 15.0636 40.7752 16.5189M38.1319 9.17646C38.1319 10.6363 36.9485 11.8197 35.4887 11.8197C34.0288 11.8197 32.8454 10.6363 32.8454 9.17646C32.8454 7.71663 34.0288 6.5332 35.4887 6.5332C36.9485 6.5332 38.1319 7.71663 38.1319 9.17646Z"
          stroke="#4520AB"
          strokeWidth="1.17478"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
